export const CONTRACT_TYPES = {
  labor: {
    label: "Hợp đồng lao động",
    color: "#1a5fb4",
    icon: "👔",
    fields: [
      { key: "employeeName", label: "Họ và tên người lao động", type: "text", required: true },
      { key: "dob", label: "Ngày sinh", type: "date", required: true },
      { key: "idNumber", label: "CMND/CCCD", type: "text", required: true },
      { key: "idDate", label: "Ngày cấp", type: "date", required: true },
      { key: "idPlace", label: "Nơi cấp", type: "text", required: true },
      { key: "phone", label: "Số điện thoại", type: "tel", required: true },
      { key: "address", label: "Địa chỉ thường trú", type: "text", required: true },
      { key: "position", label: "Chức danh chuyên môn", type: "text", required: true },
      { key: "desc", label: "Công việc phải làm", type: "text", required: true },
      { key: "salary", label: "Mức lương (VNĐ)", type: "text", required: true },
      { key: "startDate", label: "Ngày bắt đầu", type: "date", required: true },
      { key: "insurance", label: "Đóng BHXH, BHYT, BHTN", type: "checkbox", required: false },
    ]
  },
  collaborator: {
    label: "Hợp đồng cộng tác viên",
    color: "#2d6a4f",
    icon: "🤝",
    fields: [
      { key: "employeeName", label: "Họ và tên cộng tác viên", type: "text", required: true },
      { key: "dob", label: "Ngày sinh", type: "date", required: true },
      { key: "taxCode", label: "Mã số thuế", type: "text", required: false },
      { key: "idNumber", label: "CMND/CCCD", type: "text", required: true },
      { key: "idDate", label: "Ngày cấp", type: "date", required: false },
      { key: "idPlace", label: "Nơi cấp", type: "text", required: false },
      { key: "address", label: "Nơi đăng ký hộ khẩu / Liên lạc", type: "text", required: true },
      { key: "phone", label: "Số điện thoại", type: "tel", required: true },
      { key: "salary", label: "Thù lao / Lương (VNĐ)", type: "text", required: true },
      {
        key: "paymentMethod", label: "Hình thức thanh toán", type: "select", required: true,
        options: ["Chuyển khoản ngân hàng", "Tiền mặt", "Ví điện tử"]
      },
      { key: "startDate", label: "Ngày bắt đầu", type: "date", required: true },
      { key: "bankAccount", label: "Số tài khoản ngân hàng", type: "text", required: false },
      { key: "bankName", label: "Tên ngân hàng", type: "text", required: false },
    ]
  }
};
